import { Button, Dropdown, Navbar, NavbarBrand } from "react-bootstrap";
import { WalletContext } from "../../../contexts/WalletContext";
import { UserContext } from "../../../contexts/UserContext";
import { getPropicUrl } from "../../../api/endpoints";
import { useLogout } from "../../../api/query_hooks";
import Propic from "../../images/propic/Propic";
import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import "./navigationBar.scss";
import 'boxicons';

const NavigationBar = () => {

    const { user } = useContext(UserContext);
    const { address, connectWallet } = useContext(WalletContext);
    const [show, setShow] = useState(false);

    const mutation = useLogout();

    const handleConnect = async () => {
        try {
            await connectWallet();
        } catch (error) {
            console.error("Error connecting wallet:", error);
        }
    }

    const handleLogout = async () => {
        mutation.mutate();
    }


    return(
        <Navbar bg="black" className="ps-4 px-md-4 d-flex justify-content-between border-bottom border-secondary">
            <NavbarBrand as={Link} to="/" className="text-light text-bold fs-3">
                <span>Art3</span>
            </NavbarBrand>

            <div className="d-flex flex-row gap-3">
                {window.ethereum ? (
                    <Button variant="warning" className="text-dark" onClick={() => handleConnect()}>Connect wallet</Button>
                ) : (
                    <p>Wallet not found</p>
                )}
                
                {user.isLogged &&
                    <Dropdown
                        id="navbar-user-menu"
                        data-bs-theme="dark"
                        show={show} align={"end"}
                        onMouseEnter={() => setShow(true)}
                        onMouseLeave={() => setShow(false)}
                        onClick={() => setShow(!show)}
                    >
                        <Dropdown.Toggle variant="link" className="text-decoration-none d-flex jutify-content-center align-items-center gap-2" >
                            <span>{user.data?.username}</span>
                            <Propic className="w-4" src={getPropicUrl(user.data?.propic)} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item as={Link} to="/account/dashboard" className="d-flex gap-3 ps-4 py-2">
                                <box-icon color='white' type='solid' name='user-circle'></box-icon>
                                <span className="pe-5">Account</span>
                            </Dropdown.Item>
                            <Dropdown.Item as={Link} to="/account/details" className="d-flex gap-3 ps-4 py-2">
                                <box-icon color='white' type='solid' name='cog'></box-icon>
                                <span className="pe-5">Settings</span>
                            </Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Item className="d-flex gap-3 ps-4 py-2" onClick={handleLogout} >
                                <box-icon color='white' name='log-out'></box-icon>
                                <span className="pe-5">Log Out</span>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    }
            </div>
        </Navbar>
    );
}

export default NavigationBar;